import event from '@fishx/emit';
import { CHANGE_FISHX_LANGUAGE } from './index';

export default function(callback: any) {
  event.on(CHANGE_FISHX_LANGUAGE, callback);
}
